module.exports = __webpack_public_path__ + "media/components/Application/Sponsors/Index/dash_image-d8d5d77cec4cce3cae8ab9fc4b48b982.png";